import { render, staticRenderFns } from "./Summaries.vue?vue&type=template&id=3c7d81bf"
import script from "./Summaries.vue?vue&type=script&lang=js"
export * from "./Summaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports